import React from "react";
import { createPortal } from "react-dom";

export default function ContactOverlay({ open, onClose }) {
  const [mounted, setMounted] = React.useState(false);
  React.useEffect(() => { setMounted(true); }, []);
  if (!open || !mounted) return null;

  const backdropStyle = {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.5)',
    zIndex: 1000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };

  const panelStyle = {
    width: '92vw',
    maxWidth: 560,
    borderRadius: 16,
    background: 'var(--panel, #fff)',
    padding: 24,
    boxShadow: '0 10px 30px rgba(0,0,0,0.2)'
  };

  const closeBtnStyle = {
    border: 0,
    background: 'transparent',
    fontSize: 14,
    padding: '4px 8px',
    borderRadius: 999,
    cursor: 'pointer'
  };

  const titleRow = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 12
  };

  const section = { marginTop: 10, marginBottom: 10, color: 'var(--fg, #111)' };
  const label = { fontWeight: 600, color: 'var(--fg, #111)' };

  const stop = (e) => e.stopPropagation();

  const body = (
    <div role="dialog" aria-modal="true" style={backdropStyle} onClick={onClose}>
      <div style={panelStyle} onClick={stop}>
        <div style={titleRow}>
          <h2 style={{ margin: 0, fontSize: 20 }}>Contact Us</h2>
          <button onClick={onClose} style={closeBtnStyle} aria-label="Close">✕</button>
        </div>

        <div style={{ fontSize: 14, lineHeight: 1.6 }}>
          <div style={section}>
            <div style={label}>Company</div>
            <div>Anvibytes Systems</div>
          </div>
          <div style={section}>
            <div style={label}>Contact</div>
            <div>+91-9439214968</div>
          </div>
          <div style={section}>
            <div style={label}>Email</div>
            <div>sujitsahu007@gmail.com</div>
          </div>
          <div style={section}>
            <div style={label}>Address</div>
            <div>Manorama Estate, Nigamananda Nagar, Rasulgarh, Bhubaneswar, Odisha 751010</div>
          </div>
        </div>

        <div style={{ marginTop: 16, display: 'flex', justifyContent: 'flex-end' }}>
          <button onClick={onClose} style={{ background:'#111', color:'#fff', border:0, borderRadius:12, padding:'8px 14px', cursor:'pointer' }}>Close</button>
        </div>
      </div>
    </div>
  );

  return createPortal(body, document.body);
}